var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"yakiton-teruteru"}},[_c('nav-bar'),_c('banner'),_c('introduce'),_c('location'),_c('Menu'),_c('Carousel'),_c('EmployeeRecruitment'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }